import React from 'react';

export default function SorryForInconvenienceCausedPage() {
  return <>hello inconvenience caused</>;
}
